// Weight units, mirroring the server's `geargrams_core::units` so the UI
// shows the same numbers the API computes.
export type Unit = { id: number; name: string; abbreviation: string; grams: number };

export const UNITS: Unit[] = [
  { id: 1, name: "grams", abbreviation: "g", grams: 1 },
  { id: 2, name: "pound", abbreviation: "lb", grams: 453.59237 },
  { id: 3, name: "ounce", abbreviation: "oz", grams: 28.3495231 },
  { id: 4, name: "kg", abbreviation: "kg", grams: 1000 },
];

export function unitById(id: number): Unit {
  return UNITS.find((u) => u.id === id) ?? UNITS[0];
}

/** The old `MathUtil.roundTo`. */
export function roundTo(n: number, places: number): number {
  const x = Math.pow(10, places);
  return Math.round(n * x) / x;
}

/** Grams shown in a unit: two decimals (whole grams for g), as the old UI did. */
export function inUnit(grams: number, unit: Unit): number {
  return unit.id === 1 ? Math.round(grams) : roundTo(grams / unit.grams, 2);
}

export function fmt(grams: number, unit: Unit): string {
  return `${inUnit(grams, unit)}${unit.abbreviation}`;
}
